<ng-container *ngIf="basketPersons$ | async as basketPersons">
  <ssc-basket-person-detail
    *ngFor="let basketPerson of basketPersons; let index = index"
    [isOpen]="basketPerson.open || basketPersons.length === 1"
    [isTupCustomer]="isTupCustomer"
    (personToggled)="basketPerson.open = !basketPerson.open"
    (toPersonClick)="personClick.emit(basketPerson.person.personId)"
    (removeBasicInsuranceClick)="removeBasicInsuranceClick.emit(basketPerson.person.personId)"
    (removeSupplementaryInsuranceClick)="
      removeSupplementaryInsuranceClick.emit({
        personId: basketPerson.person.personId,
        supplementaryInsuranceKey: $event,
      })
    "
    [person]="basketPerson.person"
    [isSinglePerson]="basketPersons.length === 1"
    [isActivePerson]="basketPerson.isActivePerson"
  ></ssc-basket-person-detail>
</ng-container>
